// ----------------------------------4Steps-server---------------------------------------------------
// const BASE_URL =  "http://173.212.233.220:3302/api/v1";
// export const HOST_MEDIA_URL_V1 = "http://173.212.233.220:3303";
// export const WEB_PAGE_URL =  "http://mane.4steps.am";


// //----------------------------------Official-server---------------------------------------------------

const BASE_URL =  "https://app.manehblog.com/front/api/v1";
export const HOST_MEDIA_URL_V1 = "https://app.manehblog.com/file";
export const WEB_PAGE_URL =  "https://manehblog.com";

export const _hostMedia = HOST_MEDIA_URL_V1;

export const _urlLanguage = BASE_URL + "/language";
export const _urlStaticTexts = BASE_URL + "/static-texts";
export const _urlSlider = BASE_URL + "/slider";
export const _urlSubscribers = BASE_URL + "/subscriber";
export const _urlBlog = BASE_URL + "/blog";
export const _urlContact = BASE_URL + "/contact";
export const _urlAbout = BASE_URL + "/about";
export const _urlAdvertisement = BASE_URL + "/advertisement";

